// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"8d11f0a9","167":"2d66a947","518":"a20fe20a","540":"f2c800c4"}[chunkId] + ".css";
};